<template>
	<div>
		<p>
			{{
				selectRandom([
					"Participants will be recruited from ",
					"The recruitment for the study will be undertaken in ",
					"The recruitment for the study will take place in ",
					"The recruiting for the research will take place in "
				])
			}}
			{{
				joinArrayWithOr(
					formatSelectMulti($tera.project.TrialWizard.settings)
				).toLowerCase()
			}}
			{{
				selectRandom(["in ", "within ", "from ", "located in ", "based in "])
			}}
			{{ joinArrayWithOr(formatSelectMulti($tera.project.TrialWizard.regions)) }}.
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputStudySetting",
	mixins: [OutputMixin]
};
</script>
